<template>
  <div class="server-response">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.server-response {
  align-items: center;
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: 100vh;
}

@media only screen and (max-width: 720px) {
  .server-response {
    padding: 10px;
  }
}
</style>
